import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuthStore } from "@/stores/auth-store";
import { useInactivityLogout } from "@/hooks/use-inactivity-logout";
import { useRefreshWarning } from "@/hooks/use-refresh-warning";
import { RefreshWarningDialog } from "@/components/RefreshWarningDialog";
import { performLogout } from "@/lib/auth/logout";
import { toast } from "sonner";

export function ProtectedRoute() {
  const location = useLocation();
  const accessToken = useAuthStore((s) => s.accessToken);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const adminUser = useAuthStore((s) => s.adminUser);
  const isSessionValid = useAuthStore((s) => s.isSessionValid);

  // inactivity-driven 자동 logout 은 본진 운영 시 자주 풀린다는 피드백으로 비활성.
  // 백엔드 JWT TTL 만료는 isSessionValid 가 잡아서 logout 시킨다 — 그쪽은 유지.
  // 다시 정책 적용 필요하면 enabled 켜고 timeout(현재 20분) 조정.
  useInactivityLogout({ enabled: false });
  const { showWarning, dismissWarning, confirmRefresh } = useRefreshWarning();

  useEffect(() => {
    if (accessToken && !isSessionValid()) {
      performLogout();
      toast.error("세션이 만료되었습니다. 다시 로그인해주세요.");
    }
  }, [accessToken, isSessionValid]);

  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!isAuthenticated || !adminUser?.isAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <>
      <Outlet />
      <RefreshWarningDialog
        open={showWarning}
        onDismiss={dismissWarning}
        onConfirmRefresh={confirmRefresh}
      />
    </>
  );
}
